(function (w) {
  var BuyButton = {
    init: function () {
      this.initButtons();

      var self = this,
          cartHandlers = AjaxCart.getInstance().Cart.events,
          newCartHandlers = {},
          buyButtonHandlers = {
            onProductAdd: function updateBuyButtons(id) {
              if (id) {
                self.updateButtons([id]);
              }
            },
            onProductRemove: function updateBuyButtons(id) {
              if (id) {
                self.updateButtons([id])
              }
            },
            onChange: function updateBuyButtons() {
              if (this.total.quantity == 0) {
                self.updateButtons(self.ids);
              }
            }
          };

      for (var cartTriggerName in buyButtonHandlers) {
        var isCartAlreadyHasHandler = false;

        cartHandlers
        && cartHandlers[cartTriggerName]
        && cartHandlers[cartTriggerName].forEach(function (handler) {
          if (handler.name === 'updateBuyButtons') {
            isCartAlreadyHasHandler = true;

            return false;
          }
        });

        if (!isCartAlreadyHasHandler) {
          newCartHandlers[cartTriggerName] = buyButtonHandlers[cartTriggerName];
        }
      }

      AjaxCart.getInstance().attachEventHandlers(newCartHandlers);
      this.trigger('onInit');
    },

    openCart: function () {
      this.trigger('onOpenCart');
    },

    initButtons: function () {
      this.addButtons = $('.j-buy-button-add');
      this.removeButtons = $('.j-buy-button-remove');
      this.ids = [];
      var self = this;
      this.addButtons.off('click').on('click', function () {
        var me = $(this),
            id = me.attr('id').substr('j-buy-button-widget-'.length),
            gift = me.data('gift') * 1,
            quantity = me.attr('data-quantity') * 1,
            productType = me.attr('data-cartProductType');
        if (isNaN(quantity)) {
          quantity = 1;
        }

        self.ids.push(id);
        self.clickedButton = me;

        var product = {
              type: productType,
              quantity: quantity,
              id: id
            },
            related = [];

        if (gift) {
          related = [{type: 'gift', quantity: 1, id: gift}];
        }
        if (self.trigger('onBeforeAdd', product, related, self.clickedButton) !== false) {
          AjaxCart.openCartOnAdd = true;
          AjaxCart.getInstance().appendProduct(product, related);
          self.trigger('onAfterAdd', product, related);
        }

        return false;
      });

      this.removeButtons.off('click').on('click', function () {
        self.openCart();
        return false;
      });
    },

    updateButtons: function (ids) {
      var self = this,
          isMobile = false,
          skin = '';
      ids = ids instanceof Array ? ids : [ids];

      if (ids.length) {
        if (this.trigger('onBeforeUpdate') === false) {
          return;
        }

        for (var i in ids) {
          if (ids.hasOwnProperty(i)) {
            var id = ids[i];
            var container = $('[id="j-buy-button-widget-' + id + '"]')

            if (container.length && !container.is('.j-ajax-ignore')) {
              skin = container.data('skin');
              isMobile = skin && skin.indexOf('mobile') >= 0;
              isMobile
                ? this.setMobileButton(container, self.isProductInCart(id), skin)
                : this.setDesktopButton(container, self.isProductInCart(id), skin)
            }
          }
        }

        self.trigger('onAfterRender', container);
        window.requestAnimationFrame(() => self.initButtons())
      }
    },
    setDesktopButton: function (buttonEl, isProductInCart, skin) {
      isProductInCart
        ? this.updateButtonClasses(buttonEl, 'j-buy-button-remove', 'j-buy-button-add __disabled')
        : this.updateButtonClasses(buttonEl, 'j-buy-button-add', 'j-buy-button-remove')

      buttonEl.blur();
      buttonEl.find('.loader').remove();

      if (skin === 'flip') {
        buttonEl.toggle(!isProductInCart);
        buttonEl.siblings('.counter').toggle(isProductInCart);
      }

      if (skin === 'small') return;

      this.updateButtonText(buttonEl, isProductInCart);
    },
    
    setMobileButton: function (buttonEl, isProductInCart, skin) {
      isProductInCart
        ? this.updateButtonClasses(buttonEl, 'j-buy-button-remove', 'j-buy-button-add is-loading')
        : this.updateButtonClasses(buttonEl, 'j-buy-button-add', 'j-buy-button-remove')

      if (skin === 'small_mobile') return;

      this.updateButtonText(buttonEl, isProductInCart);
    },

    updateButtonText: function (buttonEl, isProductInCart) {
      const text = isProductInCart ? 'В корзине' : 'Купить';
      const contentElement = buttonEl.find('.btn-content');
      
      if (contentElement.length) {
          contentElement.text(l10n(text));
      } else {
          buttonEl.text(l10n(text));
      }
    },

    updateButtonClasses: (buttonEl, addClasses, removeClasses) => {
      buttonEl.removeClass(removeClasses).addClass(addClasses);
    },

    isProductInCart: function(id) {
      return Object.values(AjaxCart.getInstance().Cart.products).some(product => product.id === Number(id) && !product.related_to);
    }
  };

  $.extend(BuyButton, TMEvents);
  w.BuyButton = BuyButton;
  $(function () {
    BuyButton.init();
  });
}(window));
